import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'stripUsedValues',
	standalone: false,
})
export class StripUsedValuesPipe implements PipeTransform {

	transform(list: any, params: any): any {
		let output = list;
		if (params.usedSet instanceof Set && params.usedSet.size > 0) {
			let idFieldName: string = params.idField || 'id';
			output = list.filter(
				(item: any) => {
					let available = false;
					if (item) {
						// Cannot use getter / setter variable names
						if (!item.hasOwnProperty(idFieldName)) {
							idFieldName = `_${ idFieldName }`;
						}

						if (item[idFieldName]) {
							const contained = params.usedSet.has(item[idFieldName]);
							available = !contained || item[idFieldName] === params.myId;
						}
					}
					return available;
				}
			);
		}
		return output;
	}
}
